import {IKeyValueParserConfig} from "./i-key-value-parser-config";

export const keyValueParserConfig: IKeyValueParserConfig = {
	assignmentToken: ":",
	separatorToken: ";"
};